import * as Types from '../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ProfileQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', Profile?: { __typename?: 'Profile', logoURL?: string | null, foreground: string, headerTextColor: string, allowGuests: boolean, fabColor: string, fabLogoURL?: string | null, notificationColor: string, showStatusPage: boolean, showKnowledgeBase: boolean, title: Array<{ __typename?: 'LocalizedString', language: string, value: string }>, subtitle: Array<{ __typename?: 'LocalizedString', language: string, value: string }>, background: { __typename?: 'HeadingBackground', color: string, background: string }, inbox: { __typename?: 'Inbox', workWeek: { __typename?: 'WorkWeek', timezone: string, monday: Array<{ __typename?: 'WorkHourRule', from: string, to: string }>, tuesday: Array<{ __typename?: 'WorkHourRule', from: string, to: string }>, wednesday: Array<{ __typename?: 'WorkHourRule', from: string, to: string }>, thursday: Array<{ __typename?: 'WorkHourRule', from: string, to: string }>, friday: Array<{ __typename?: 'WorkHourRule', from: string, to: string }>, saturday: Array<{ __typename?: 'WorkHourRule', from: string, to: string }>, sunday: Array<{ __typename?: 'WorkHourRule', from: string, to: string }> }, users: Array<{ __typename?: 'MemberUser', _id: string, name?: string | null, logoURL?: string | null, lastName: string, firstName: string }> }, account?: { __typename?: 'Account', name: string, slug: string, website: string, clientPortal: { __typename?: 'ClientPortal', knowledgeBaseEnabled?: boolean | null, statusPageEnabled?: boolean | null, customDomain?: string | null } } | null, visitor?: { __typename?: 'Visitor', _id: string, type: Types.AuthenticationType, name?: string | null, email?: string | null, image?: string | null } | null } | null };


export const ProfileDocument = gql`
    query Profile {
  Profile {
    title {
      language
      value
    }
    subtitle {
      language
      value
    }
    logoURL
    foreground
    headerTextColor
    allowGuests
    fabColor
    fabLogoURL
    notificationColor
    background {
      color
      background
    }
    showStatusPage
    showKnowledgeBase
    inbox {
      workWeek {
        timezone
        monday {
          from
          to
        }
        tuesday {
          from
          to
        }
        wednesday {
          from
          to
        }
        thursday {
          from
          to
        }
        friday {
          from
          to
        }
        saturday {
          from
          to
        }
        sunday {
          from
          to
        }
      }
      users {
        _id
        name
        logoURL
        lastName
        firstName
      }
    }
    account {
      name
      slug
      website
      clientPortal {
        knowledgeBaseEnabled
        statusPageEnabled
        customDomain
      }
    }
    visitor {
      _id
      type
      name
      email
      image
    }
  }
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = ApolloReactCommon.QueryResult<ProfileQuery, ProfileQueryVariables>;